export const TOPIC_MULTI_DIMS = [
  { key: "topic_area", label: "Topic Area", required: true },
  { key: "angle_type", label: "Angle Type", required: true },
  { key: "sector", label: "Sector", required: false },
  { key: "geography", label: "Geography", required: false },
  { key: "event_type", label: "Event Type", required: false },
  { key: "asset_class", label: "Asset Class", required: false },
  { key: "theme", label: "Theme", required: false },
] as const;

export const TOPIC_SINGLE_DIMS = [
  { key: "time_mode", label: "Time Mode" },
  { key: "difficulty", label: "Difficulty" },
] as const;
